<div class="d-flex justify-content-between">
    <div class="form-group" *ngIf="selectedName != null">
      <div class="dropdown dropdown-bhp">
        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
          <input class="dropdown-toggle" [ngModel]="selectedName | translate" type="text" readonly />
          <span class="label-dropdown"></span>
          <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
        </div>
        <ul class="dropdown-menu">
          <li class="dropdown-item" (click)="onSelectChange('totalConsumption')" value="totalConsumption" [ngClass]="select === 'totalConsumption' ? 'active' : ''" >{{ 'EVALUATION.CONSUMPTION.TOTAL_CONSUMPTION_TITLE' | translate }}</li>
          <li class="dropdown-item" (click)="onSelectChange('consumptionPerPatient')" value="consumptionPerPatient" [ngClass]="select === 'consumptionPerPatient' ? 'active' : ''" >{{ 'EVALUATION.CONSUMPTION.CONSUMPTION_PER_PATIENT_TITLE' | translate }}</li>
      </ul>
      </div>
    </div>


</div>

<kendo-excelexport [data]="gridData" [fileName]="getFileName('xlsx')" #excelexport>
    <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}"
        *ngFor="let i of fields,  let indexx = index;" class="non-action-columns" [width]="i.width">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="i.ngTemplate">
            {{i.ngTemplate(dataItem)}}
        </ng-template>
    </kendo-excelexport-column>
</kendo-excelexport>

<ng-container *ngFor="let result of results">
  <kendo-excelexport [data]="result.gridData" filename="ReportMyHygieneSOP.xlsx" #multiselectExcelExport>
    <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}"
        *ngFor="let i of result.fields,  let indexx = index;" class="non-action-columns" [width]="i.width">
       <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="i.ngTemplate">
        {{i.ngTemplate(dataItem)}}
        </ng-template>
    </kendo-excelexport-column>
  </kendo-excelexport>
</ng-container>